export enum PasswordTypeEnum {
  NORMAL = 'normal',
  CURRENT = 'current',
  NEW = 'new',
  CONFIRMATION = 'confirmation'
}

export namespace PasswordTypeEnum {
  export const valueOf = (passwordType?: string): PasswordTypeEnum | undefined => {
    const keys = Object.keys(PasswordTypeEnum)
    const toTest = passwordType?.toUpperCase() ?? 'undefined'
    const isPresent = keys.includes(toTest.toUpperCase())
    return passwordType != null && isPresent
      ? PasswordTypeEnum[passwordType.toUpperCase()]
      : undefined
  }
}